<template>
  <div class="dashboard">
    <TabView :tabs="tabs">
      <template #region>
        <PerformancesWithLines :role="USER_ROLES.REGION_MANAGER"
      /></template>
      <template #store>
        <PerformancesWithPie :role="USER_ROLES.REGION_MANAGER"
      /></template>
    </TabView>
  </div>
</template>
<script>
import PerformancesWithLines from "@/components/dashboard/PerformancesWithLines.vue";
import PerformancesWithPie from "@/components/dashboard/PerformancesWithPie.vue";
import TabView from "@/components/common/TabView.vue";
import { USER_ROLES } from "@/consts";
import normalPage from "@/mixins/normal-page";
export default {
  mixins: [normalPage],
  components: {
    TabView,
    PerformancesWithLines,
    PerformancesWithPie,
  },
  data() {
    return {
      USER_ROLES,
      tabs: [
        {
          key: "region",
          label: "区域业绩",
        },
        {
          key: "store",
          label: "店铺业绩",
        },
      ],
    };
  },
};
</script>
<style lang="less">
.dashboard {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  border-top: solid 2px #f2f2f2;
}
</style>
